/**
 * Shared error codes and the kid-friendly error shape.
 *
 * The API throws `ApiError` (defined server-side) but the wire shape and the
 * code union live here so the web client and runner can reason about them.
 * kidMessage strings are friendly, plain, and contain no em dashes.
 */
export const ERROR_CODES = [
    'bad_request',
    'unauthorized',
    'forbidden',
    'not_found',
    'conflict',
    'validation_error',
    'rate_limited',
    'limit_reached',
    'needs_reauth',
    'not_configured',
    'flagged',
    'payment_required',
    'session_error',
    'internal',
];
export function isErrorCode(value) {
    return ERROR_CODES.includes(value);
}
/** HTTP status that best fits each error code. */
export const ERROR_STATUS = {
    bad_request: 400,
    unauthorized: 401,
    forbidden: 403,
    not_found: 404,
    conflict: 409,
    validation_error: 422,
    rate_limited: 429,
    limit_reached: 429,
    needs_reauth: 409,
    not_configured: 503,
    flagged: 422,
    payment_required: 402,
    session_error: 500,
    internal: 500,
};
/** Default friendly copy per code. No em dashes, no jargon. */
export const DEFAULT_KID_MESSAGES = {
    bad_request: 'Something about that request looked off. Give it another try.',
    unauthorized: 'You need to sign in first.',
    forbidden: 'This one is not yours to open.',
    not_found: 'We could not find that. It may have moved.',
    conflict: 'That name is already taken. Try a different one.',
    validation_error: 'Something in there needs a fix before we can save it.',
    rate_limited: 'Whoa, slow down a little. Try again in a moment.',
    limit_reached: 'You hit your build limit for now. You can build again soon.',
    needs_reauth: 'A grown up needs to reconnect the account before you keep going.',
    not_configured: 'This feature is not set up yet. Check back later.',
    flagged: 'A grown up needs to take a look at that before it goes through.',
    payment_required: 'A grown up needs to turn on the plan before you can start building.',
    session_error: 'Your building room had a hiccup. We are getting it back up.',
    internal: 'Something broke on our side. It is not your fault. Try again in a bit.',
};
/** Build a KidError, filling in the default friendly copy when none is given. */
export function kidError(code, message, kidMessage, resetsAt) {
    return {
        code,
        message,
        kidMessage: kidMessage ?? DEFAULT_KID_MESSAGES[code],
        ...(resetsAt ? { resetsAt } : {}),
    };
}
//# sourceMappingURL=errors.js.map